/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface LineItemTaxBase
 */
export interface LineItemTaxBaseOptional {
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  unitAmountTaxableCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  amountBaseCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  amountTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  amountPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  amountRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  amountToRefundCents?: number;
  /**
   *
   * @type {string}
   * @memberof LineItemTaxBase
   */
  taxRateUsed?: string;
}

export interface LineItemTaxBase extends LineItemTaxBaseOptional {
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  unitAmountTaxableCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  amountBaseCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  amountTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  amountPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  amountRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  amountToRefundCents?: number;
  /**
   *
   * @type {string}
   * @memberof LineItemTaxBase
   */
  taxRateUsed?: string;
}

export interface LineItemTaxBaseTrackedI {
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  unitAmountTaxableCents?: number;
  unitAmountTaxableCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  amountBaseCents?: number;
  amountBaseCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  amountTotalCents?: number;
  amountTotalCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  amountPaidCents?: number;
  amountPaidCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  amountRefundedCents?: number;
  amountRefundedCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxBase
   */
  amountToRefundCents?: number;
  amountToRefundCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemTaxBase
   */
  taxRateUsed?: string;
  taxRateUsedIsSet: boolean;
}

transformDatesMap.set("LineItemTaxBase", function (model: LineItemTaxBase) {});

export type LineItemTaxBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  unitAmountTaxableCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountBaseCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountRefundedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountToRefundCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  taxRateUsed: PropertyMeta<MetaTypeBase<string>>;
}>;

export var LineItemTaxBaseMeta: LineItemTaxBaseMetaI =
  {} as LineItemTaxBaseMetaI;
LineItemTaxBaseMeta = typeMeta("LineItemTaxBase", {
  unitAmountTaxableCents: propertyMeta(
    "unitAmountTaxableCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountBaseCents: propertyMeta(
    "amountBaseCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTotalCents: propertyMeta(
    "amountTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountPaidCents: propertyMeta(
    "amountPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountRefundedCents: propertyMeta(
    "amountRefundedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountToRefundCents: propertyMeta(
    "amountToRefundCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  taxRateUsed: propertyMeta(
    "taxRateUsed",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = LineItemTaxBaseMeta;

registerMeta(() => {});

export class LineItemTaxBaseTracked implements LineItemTaxBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  unitAmountTaxableCents__I?: number = undefined;
  unitAmountTaxableCentsIsSet: boolean = false;
  set unitAmountTaxableCents(v: undefined | number) {
    if (v !== undefined) {
      this.unitAmountTaxableCents__I = v;
      this.unitAmountTaxableCentsIsSet = true;
    } else {
      this.unitAmountTaxableCents__I = v || undefined;
      this.unitAmountTaxableCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get unitAmountTaxableCents() {
    return this.unitAmountTaxableCents__I;
  }
  amountBaseCents__I?: number = undefined;
  amountBaseCentsIsSet: boolean = false;
  set amountBaseCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountBaseCents__I = v;
      this.amountBaseCentsIsSet = true;
    } else {
      this.amountBaseCents__I = v || undefined;
      this.amountBaseCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountBaseCents() {
    return this.amountBaseCents__I;
  }
  amountTotalCents__I?: number = undefined;
  amountTotalCentsIsSet: boolean = false;
  set amountTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTotalCents__I = v;
      this.amountTotalCentsIsSet = true;
    } else {
      this.amountTotalCents__I = v || undefined;
      this.amountTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTotalCents() {
    return this.amountTotalCents__I;
  }
  amountPaidCents__I?: number = undefined;
  amountPaidCentsIsSet: boolean = false;
  set amountPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountPaidCents__I = v;
      this.amountPaidCentsIsSet = true;
    } else {
      this.amountPaidCents__I = v || undefined;
      this.amountPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountPaidCents() {
    return this.amountPaidCents__I;
  }
  amountRefundedCents__I?: number = undefined;
  amountRefundedCentsIsSet: boolean = false;
  set amountRefundedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountRefundedCents__I = v;
      this.amountRefundedCentsIsSet = true;
    } else {
      this.amountRefundedCents__I = v || undefined;
      this.amountRefundedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountRefundedCents() {
    return this.amountRefundedCents__I;
  }
  amountToRefundCents__I?: number = undefined;
  amountToRefundCentsIsSet: boolean = false;
  set amountToRefundCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountToRefundCents__I = v;
      this.amountToRefundCentsIsSet = true;
    } else {
      this.amountToRefundCents__I = v || undefined;
      this.amountToRefundCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountToRefundCents() {
    return this.amountToRefundCents__I;
  }
  taxRateUsed__I?: string = undefined;
  taxRateUsedIsSet: boolean = false;
  set taxRateUsed(v: undefined | string) {
    if (v !== undefined) {
      this.taxRateUsed__I = v;
      this.taxRateUsedIsSet = true;
    } else {
      this.taxRateUsed__I = v || undefined;
      this.taxRateUsedIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxRateUsed() {
    return this.taxRateUsed__I;
  }
  constructor(config?: LineItemTaxBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: LineItemTaxBaseOptional,
    options?: AssignOptions,
  ): LineItemTaxBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.unitAmountTaxableCents &&
      this.unitAmountTaxableCentsApplyFilter(optionsRequired.filter)
    ) {
      this.unitAmountTaxableCents = config.unitAmountTaxableCents;
      if (optionsRequired.unassign) this.unitAmountTaxableCentsIsSet = false;
      else this.unitAmountTaxableCentsIsSet = true;
    }
    if (
      config.amountBaseCents &&
      this.amountBaseCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountBaseCents = config.amountBaseCents;
      if (optionsRequired.unassign) this.amountBaseCentsIsSet = false;
      else this.amountBaseCentsIsSet = true;
    }
    if (
      config.amountTotalCents &&
      this.amountTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTotalCents = config.amountTotalCents;
      if (optionsRequired.unassign) this.amountTotalCentsIsSet = false;
      else this.amountTotalCentsIsSet = true;
    }
    if (
      config.amountPaidCents &&
      this.amountPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountPaidCents = config.amountPaidCents;
      if (optionsRequired.unassign) this.amountPaidCentsIsSet = false;
      else this.amountPaidCentsIsSet = true;
    }
    if (
      config.amountRefundedCents &&
      this.amountRefundedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountRefundedCents = config.amountRefundedCents;
      if (optionsRequired.unassign) this.amountRefundedCentsIsSet = false;
      else this.amountRefundedCentsIsSet = true;
    }
    if (
      config.amountToRefundCents &&
      this.amountToRefundCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountToRefundCents = config.amountToRefundCents;
      if (optionsRequired.unassign) this.amountToRefundCentsIsSet = false;
      else this.amountToRefundCentsIsSet = true;
    }
    if (
      config.taxRateUsed &&
      this.taxRateUsedApplyFilter(optionsRequired.filter)
    ) {
      this.taxRateUsed = config.taxRateUsed;
      if (optionsRequired.unassign) this.taxRateUsedIsSet = false;
      else this.taxRateUsedIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): LineItemTaxBaseTrackedI {
    const cloned = {} as LineItemTaxBaseTrackedI;
    if (
      this.unitAmountTaxableCentsIsSetDeep() &&
      this.unitAmountTaxableCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.unitAmountTaxableCentsIsSet = true;
      cloned.unitAmountTaxableCents = this.unitAmountTaxableCents;
    } else {
      //cloned.unitAmountTaxableCentsIsSet = false
    }
    if (
      this.amountBaseCentsIsSetDeep() &&
      this.amountBaseCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountBaseCentsIsSet = true;
      cloned.amountBaseCents = this.amountBaseCents;
    } else {
      //cloned.amountBaseCentsIsSet = false
    }
    if (
      this.amountTotalCentsIsSetDeep() &&
      this.amountTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTotalCentsIsSet = true;
      cloned.amountTotalCents = this.amountTotalCents;
    } else {
      //cloned.amountTotalCentsIsSet = false
    }
    if (
      this.amountPaidCentsIsSetDeep() &&
      this.amountPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountPaidCentsIsSet = true;
      cloned.amountPaidCents = this.amountPaidCents;
    } else {
      //cloned.amountPaidCentsIsSet = false
    }
    if (
      this.amountRefundedCentsIsSetDeep() &&
      this.amountRefundedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountRefundedCentsIsSet = true;
      cloned.amountRefundedCents = this.amountRefundedCents;
    } else {
      //cloned.amountRefundedCentsIsSet = false
    }
    if (
      this.amountToRefundCentsIsSetDeep() &&
      this.amountToRefundCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountToRefundCentsIsSet = true;
      cloned.amountToRefundCents = this.amountToRefundCents;
    } else {
      //cloned.amountToRefundCentsIsSet = false
    }
    if (
      this.taxRateUsedIsSetDeep() &&
      this.taxRateUsedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxRateUsedIsSet = true;
      cloned.taxRateUsed = this.taxRateUsed;
    } else {
      //cloned.taxRateUsedIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): LineItemTaxBaseTrackedI {
    if (!this.unitAmountTaxableCentsApplyFilter(filter))
      this.unitAmountTaxableCentsIsSet = false;

    if (!this.amountBaseCentsApplyFilter(filter))
      this.amountBaseCentsIsSet = false;

    if (!this.amountTotalCentsApplyFilter(filter))
      this.amountTotalCentsIsSet = false;

    if (!this.amountPaidCentsApplyFilter(filter))
      this.amountPaidCentsIsSet = false;

    if (!this.amountRefundedCentsApplyFilter(filter))
      this.amountRefundedCentsIsSet = false;

    if (!this.amountToRefundCentsApplyFilter(filter))
      this.amountToRefundCentsIsSet = false;

    if (!this.taxRateUsedApplyFilter(filter)) this.taxRateUsedIsSet = false;

    return this;
  }
  unitAmountTaxableCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxBaseMeta.unitAmountTaxableCents,
      LineItemTaxBaseMeta,
      this.unitAmountTaxableCents,
      this,
    );
  }
  unitAmountTaxableCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.unitAmountTaxableCentsIsSet &&
      this.unitAmountTaxableCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountBaseCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxBaseMeta.amountBaseCents,
      LineItemTaxBaseMeta,
      this.amountBaseCents,
      this,
    );
  }
  amountBaseCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountBaseCentsIsSet && this.amountBaseCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxBaseMeta.amountTotalCents,
      LineItemTaxBaseMeta,
      this.amountTotalCents,
      this,
    );
  }
  amountTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTotalCentsIsSet && this.amountTotalCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxBaseMeta.amountPaidCents,
      LineItemTaxBaseMeta,
      this.amountPaidCents,
      this,
    );
  }
  amountPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountPaidCentsIsSet && this.amountPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountRefundedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxBaseMeta.amountRefundedCents,
      LineItemTaxBaseMeta,
      this.amountRefundedCents,
      this,
    );
  }
  amountRefundedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountRefundedCentsIsSet &&
      this.amountRefundedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountToRefundCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxBaseMeta.amountToRefundCents,
      LineItemTaxBaseMeta,
      this.amountToRefundCents,
      this,
    );
  }
  amountToRefundCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountToRefundCentsIsSet &&
      this.amountToRefundCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  taxRateUsedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxBaseMeta.taxRateUsed,
      LineItemTaxBaseMeta,
      this.taxRateUsed,
      this,
    );
  }
  taxRateUsedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxRateUsedIsSet && this.taxRateUsedApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.unitAmountTaxableCentsIsSetDeep(filter)) return true;
    if (this.amountBaseCentsIsSetDeep(filter)) return true;
    if (this.amountTotalCentsIsSetDeep(filter)) return true;
    if (this.amountPaidCentsIsSetDeep(filter)) return true;
    if (this.amountRefundedCentsIsSetDeep(filter)) return true;
    if (this.amountToRefundCentsIsSetDeep(filter)) return true;
    if (this.taxRateUsedIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
